import type { AdminAccount, CreateAdminInput, UpdateAdminInput } from '@/types/adminAccount.types';

import { apiClient } from './api.service';

export const adminAccountsApi = {
  list: () => apiClient.get<AdminAccount[]>('/admin/admins').then((r) => r.data),

  create: (body: CreateAdminInput) =>
    apiClient.post<AdminAccount>('/admin/admins', body).then((r) => r.data),

  /** Re-sends the activation email for an account still in `invited` status. */
  resendInvite: (id: string) =>
    apiClient.post<AdminAccount>(`/admin/admins/${id}/resend-invite`, {}).then((r) => r.data),

  update: (id: string, body: UpdateAdminInput) =>
    apiClient.patch<AdminAccount>(`/admin/admins/${id}`, body).then((r) => r.data),
};
